<template>
  <el-dialog :title="$t('text.delete')"
             :close-on-click-modal="false"
             :visible.sync="show"
             size="tiny"
             :before-close="handleColse">
    <span>{{$t('text.sureDelete')}}{{title}}：{{deleteNo}}?</span>
    <span slot="footer"
          class="dialog-footer">
      <el-button size="small"
                 @click="handleColse()">{{$t('text.cancel')}}</el-button>
      <el-button size="small"
                 type="primary"
                 :disabled="debounced"
                 @click="deleteConfirm">{{$t('text.confirm')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'Delete',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    deleteId: {
      type: [String, Number],
      default: ''
    },
    deleteNo: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      show: false, // 是否显示删除弹框
      debounced: false
    };
  },
  mounted () {
    this.show = this.visible;
  },
  methods: {
    handleColse () {
      this.show = false;
      this.$emit('update:visible', false);
    },
    deleteConfirm () {
      this.debounced = true;
      this.$emit('handleDelete', this);
    }
  }
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/workSheet/common/delete.vue